import { render, staticRenderFns } from "./ViewProductView.vue?vue&type=template&id=2309627c"
import script from "./ViewProductView.vue?vue&type=script&lang=js"
export * from "./ViewProductView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports